"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.title.placeholder': 'Wprowadź tytuł wiedzy',
};
